export const APP = {
    SESSION: 'SESSION',
}

export const FLYBITS = {
    WEB_CLIENT_ID: process.env.REACT_APP_FLYBITS_WEB_CLIENT_ID,
    WEB_HOST: process.env.REACT_APP_FLYBITS_WEB_HOST,

    API_HOST: process.env.REACT_APP_FLYBITS_HOST,
    IDP_HOST: process.env.REACT_APP_FLYBITS_IDP_HOST,
    SANDBOX_HOST: process.env.REACT_APP_FLYBITS_SANDBOX_HOST,
    PROXY_HOST: process.env.REACT_APP_FLYBITS_PROXY_HOST,
    AUTH_HOST: process.env.REACT_APP_FLYBITS_AUTH_HOST,
    CONFIGS_HOST: process.env.REACT_APP_FLYBITS_CONFIGS_HOST,
    I9N_HOST: process.env.REACT_APP_FLYBITS_I9N_HOST,
}

export const FLYBITS_HEADERS = {
    AUTH: 'x-authorization',
}

export const TENANT = {
    NO_TENANT: '00000000-0000-0000-0000-000000000000',
    NO_TENANT_NAME: 'All Tenants'
}



// WEBPACK FOOTER //
// ./src/constants/index.tsx